{
  "tabsAriaLabel": "Skogeiernavigasjon",
  "tabs": {
    "overview": "Oversikt",
    "property": "Eiendom",
    "shareOwnership": "Andelseierskap",
    "assignments": "Oppdrag",
    "documents": "Dokumenter",
    "economy": "Økonomi",
    "fsc": "FSC",
    "history": "Historikk"
  },
  "editInformationButton": "Endre skogeieropplysninger",
  "actionsAriaLabel": "Handlinger for skogeier",
  "changeForestOwnerType": {
    "action": "Endre skogeiertype",
    "dialogTitle": "Endre skogeiertype",
    "dialogDescription": "Endringen kan påvirke eksisterende data og kan kreve at du må fylle inn ny informasjon",
    "radioLabel": "Velg ny skogeiertype",
    "partnershipLabel": "Endre til sameie",
    "organizationLabel": "Endre til organisasjon",
    "cancelButton": "Avbryt",
    "nextButton": "Neste"
  },
  "editContactPrefsButton": "Kontaktpreferanser",
  "editContactPrefsLinkDescription": "Endre skogeiers kontaktvalg",
  "oppdragButton": "Oppdrag",
  "oppdragLinkDescription": "Se oversikt over oppdrag",
  "smsButton": "Send SMS",
  "smsLinkDescription": "Send en SMS til skogeier",
  "generalInformation": {
    "sectionTitle": "Skogeierinformasjon",
    "representativeSectionTitle": "Representant",
    "postAndBillingAddressSectionTitle": "Post og fakturaadresse",
    "name": "Navn",
    "address": "Adresse",
    "birthNumber": "Fødselsnummer",
    "bankAccount": "Bankkonto",
    "email": "E-post",
    "registrated": "Registrert",
    "shareholder": "Andelseier",
    "shares": "Andeler",
    "telefone": "Telefon"
  },
  "additionalInformation": {
    "title": "Tilleggsinformasjon",
    "information": "Informasjon",
    "description": "Legg til eventuell annen informasjon tilknyttet skogeier",
    "addButton": "Legg til",
    "editButton": "Endre beskrivelsen",
    "selectInformationType": "Velg informasjonstype",
    "duplicateInformationType": "Denne informasjonstypen er allerede lagt til",
    "descriptionPlaceholder": "Valgfri beskrivelse",
    "descriptionLabel": "Beskrivelse",
    "option1": "Driftskreditt",
    "option2": "EHF-registrert",
    "option3": "Eierskiftetillegg",
    "option4": "FSC-godkjent",
    "option5": "Godkjent grønn leverandør",
    "option6": "Kan ha ny skogfondstrekk ned til 0%",
    "option7": "Mangler landskapsplan",
    "option8": "Mangler miljøregistrering",
    "option9": "Meldeplikt",
    "option10": "MIS-godkjent",
    "option11": "PEFC kompetanse egen skog gjennomført",
    "option12": "PEFC kompetanse entreprenører",
    "option13": "Samtykke regnskapskontor",
    "option14": "Sertifiseringsavtale inngått",
    "emptyState": {
      "title": "Ingen tilleggsinformasjon registrert",
      "description": "Trykk på \"legg til\" knappen for legge inn opplysninger"
    }
  },
  "historyTabsAriaLabel": "Historikknavigasjon",
  "historyTabsEvents": "Hendelser",
  "historyTabsSms": "SMS",
  "historyTitle": "Historikk",
  "historyDescription": "Oversikt over hendelser og SMS-utsendelser",
  "subscription": {
    "title": "Abonnement på Magasinet Skog",
    "description": "Endre og administrer abonnementstatus",
    "descriptionInactive": "Opprett et nytt abonnement",
    "endingDescription": "Avsluttes {{date}}",
    "dialogTitle": "Endre abonnement",
    "dialogTitleInactive": "Opprett abonnement",
    "dialogDescription": "Gjør endringer eller avslutt abonnement",
    "dialogDescriptionInactive": "Opprett et nytt abonnement for Magasinet Skog",
    "endingDialogTitle": "Abonnementet avsluttes snart",
    "endingDialogDescription": "Etter avslutning vil skogeier vil ikke lengre motta Magasinet Skog",
    "endingDateLabel": "Avslutningsdato",
    "endingDateHelperText": "Valgt avslutningsdato. Kan ikke endres.",
    "createNewSubscriptionButton": "Opprett nytt abonnement",
    "closeButton": "Lukk",
    "dialogCloseButton": "Avslutt abonnement",
    "alertDialogTitle": "Er du sikker på at du vil avslutte abonnementet?",
    "alertDialogDescription": "Skogeier vil ikke lengre motta Magasinet Skog",
    "alertDialogAction": "Avslutt abonnement",
    "pricePlanLabel": "Prisplan",
    "pricePlanDescription": "Velg prisplanen som skal følges",
    "numberOfCopiesLabel": "Antall",
    "numberOfCopiesDescription": "Antall eksemplarer av Magasinet Skog",
    "fromDateLabel": "Fra dato",
    "fromDateDescription": "Velg datoen abonnementet skal starte",
    "toDateOptionalLabel": "Til dato (valgfritt)",
    "toDateDescription": "Velg datoen abonnementet skal avsluttes"
  },
  "documents": {
    "title": "Dokumenter",
    "description": "Oversikt over alle dokumenter knyttet til denne skogeieren",
    "uploadButton": "Last opp nytt dokument",
    "newestFirst": "Nyeste først",
    "oldestFirst": "Eldste først",
    "selectPeriod": "Velg periode",
    "allTypes": "Vis alle typer",
    "loading": "Laster dokumenter...",
    "visible": "Synlig",
    "notVisible": "Ikke synlig",
    "columns": {
      "document": "Dokument",
      "type": "Type",
      "visible": "Synlig for skogeier",
      "uploadedBy": "Opplastet av",
      "uploadedDate": "Opplastet dato"
    },
    "actions": {
      "download": "Last ned",
      "edit": "Endre",
      "delete": "Slett"
    },
    "delete": {
      "title": "Slett dokument",
      "description": "Er du sikker på at du vil slette dette dokumentet? Denne handlingen kan ikke angres."
    },
    "upload": {
      "title": "Last opp nytt dokument",
      "typeLabel": "Dokumenttype",
      "typePlaceholder": "Velg dokumenttype",
      "descriptionLabel": "Beskrivelse",
      "visibleLabel": "Synlig for skogeier",
      "fileLabel": "Fil"
    },
    "edit": {
      "title": "Endre dokument"
    }
  },
  "shareOwnership": {
    "annualStatements": "Årsoppgaver",
    "viewAnnualStatements": "Se alle årsoppgaver"
  }
}
